import React, { useEffect, useState } from 'react'
import _ from 'lodash';
import { useNavigate, useParams } from 'react-router-dom';
import { useSelector } from 'react-redux';
import * as R from 'ramda';
import JobComponent from '../components/job.component';
import { useAppDispatch, useAppSelector } from '../../../../../hooks/hooks';
import { agents } from '../../../../../redux/agents/action';
import { jobs } from '../../../../../redux/jobs/action';
import { selectJobsQueryItems } from '../../../../../redux/jobs/selector';
import { selectAgentsListItems } from '../../../../../redux/agents/selector';
import PageLoader from '../../../../../components/PageLoader';


const RapAgentJob = () => {
      const navigate = useNavigate()
      const dispatch = useAppDispatch()
      const parmas: any = useParams()
      const [isLoading, setIsLoading] = useState<boolean>(true)
      const JobQuery = useSelector(selectJobsQueryItems)
      const transportAgentListItems = useSelector(selectAgentsListItems)
      const [isQuery, setIsQuery] = useState<boolean>(false)
      const [generateIds, setGenerateIds] = useState<any>([]);
      const [
        jobDetails,
        setJobDetails
      ] = useState<any>([])
    
    
      const fetchJobById = () => {
        dispatch(jobs.query({
          url: `https://impapi.digiit.${process.env.REACT_APP_API_URL}/api/v4.0/smart-booking/jobs/query`, entity: 'jobs', jsonData: {
    
            Records: [
          {
            Id: parmas?.id

          }
        ]
    
          }
        })).then(() => {
          setIsQuery(true)
        }).then(() => {
          setIsLoading(false)
        })
      }
      const getTransporterAgentName = (TransportAgentId: any) => {
        const transportagentName = R.find(
          (transportagent: any) => parseInt(
            transportagent.Id,
            10
          ) === parseInt(
            TransportAgentId,
            10
          ),
          transportAgentListItems.result.items
    
        )
        return transportagentName ? transportagentName.Name : ''
    
      }
    
      useEffect(
        () => {
          dispatch(agents.list({
            url: `https://impapi.digiit.${process.env.REACT_APP_API_URL}/api/v4.0/rap-manager/agents/list`, entity: 'agents', jsonData: {
    
            }
          }))
          if (parmas?.id > 0) {
            fetchJobById()
          } else {
            setIsLoading(false)
          }
        },
        []
      )
      useEffect(
        () => {
    
          if (isQuery) {
            setJobDetails(JobQuery?.result?.items)
            setIsLoading(false)
          }
        },
        [isQuery]
      )
     
    
     
      const back = () => {
        navigate('/rap-agent/smart-booking/job')
      }
     
     
      return (
        <>
        
          {isLoading ? <PageLoader /> :
            <JobComponent
              back={back}
              jobDetails={jobDetails}
              getTransporterAgentName={getTransporterAgentName}
              
            />}
        </>
      )
    
    }
    
    export default RapAgentJob;